import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getRoleDetails } from "./actions";

export const roleEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.roleName,
});

const initialState = roleEntityAdapter.getInitialState({});

export const roleSlice = createSlice({
  name: "role",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoleDetails.fulfilled, (state, action) => {
      if (action.payload.status) {
        roleEntityAdapter.upsertOne(state, action.payload.data);
      }
    });
  },
});

export default roleSlice.reducer;
